import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageProgressRequest } from './get-collection-triage-progress-request';
import type { IGetCollectionTriageProgressResponse } from './get-collection-triage-progress-response';
import { getCollectionTriageProgressResponseSchema } from './get-collection-triage-progress-response';

export async function getCollectionTriageProgressApi({
  collectionId,
}: IGetCollectionTriageProgressRequest): Promise<
  IValidatedResponse<IGetCollectionTriageProgressResponse>
> {
  return getRequest<IGetCollectionTriageProgressResponse>({
    path: `/sys/collections/${collectionId}/triage/progress`,
    schema: getCollectionTriageProgressResponseSchema,
  });
}
